export function splitString(txt) {
  const txtArray = txt.split('/');
  return (txtArray.length == 2) ? 'everything' : txtArray.slice(-1).pop();
};

export function removeHidden(array) {
  const filtered = _.filter(array, {
    is_hidden : false
  });
  return (filtered.length != 0) ? filtered : array;
};



// WEBPACK FOOTER //
// ./src/scripts/filter-scripts.js